import { useTranslation } from "react-i18next";
import { FoodsIcon } from "@foodpilot/foods";
import {
    MAX_RECALCULATION_PAGE_ENTITIES,
    type ScoreRecalculationEntity,
} from "src/api/client-api/scoreRecalculation/useScoreRecalculation";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import {
    ScoreRecalculationEntityKind,
    ScoreRecalculationModal,
} from "src/components/Grid/ScoreRecalculation/ScoreRecalculationModal";
import type { TableAction } from "./GridTableActions";

type UseScoreRecalculationActionOptions = {
    path: string;
    entityKind: ScoreRecalculationEntityKind;
    invalidatedQueryKey: string;
    pageEntities: ScoreRecalculationEntity[];
    campaignId?: number;
    organizationId?: number;
};

export const useScoreRecalculationAction = (options: UseScoreRecalculationActionOptions): TableAction => {
    const { path, entityKind, invalidatedQueryKey, pageEntities, campaignId, organizationId } = options;
    const { t } = useTranslation();
    const { isAdmin } = useFoodpilotContext();

    return {
        icon: <FoodsIcon icon="calculate" size={2} />,
        label: t("grid.table_actions.recalculate_scores", "Recalculate this page's scores"),
        shouldShow: isAdmin,
        isDisabled:
            campaignId === undefined ||
            organizationId === undefined ||
            pageEntities.length === 0 ||
            pageEntities.length > MAX_RECALCULATION_PAGE_ENTITIES,
        renderPopover: (_anchor, onClose) =>
            campaignId !== undefined &&
            organizationId !== undefined && (
                <ScoreRecalculationModal
                    path={path}
                    pageEntities={pageEntities}
                    campaignId={campaignId}
                    organizationId={organizationId}
                    invalidatedQueryKey={invalidatedQueryKey}
                    entityKind={entityKind}
                    onClose={onClose}
                />
            ),
    };
};
